import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import find from 'lodash/find'
import shortid from 'shortid'
import { DataInput, EmptyInput } from './input-col'
import { InfoData, TaskData } from './info-col'
import { ApproverRow } from './approver-row'
import * as timesheetHelper from '../../helpers/timesheet'

const filterTimesheetApproval = (data, myProjects, locations, searchApprovalDetail) => {
  return data.filter((element) => {
    const search = searchApprovalDetail.toLowerCase()
    const project = find(myProjects, { _id: element.project_id })
    const projectCode = project ? project.project_code.toLowerCase() : ''
    const projectName = project ? project.name.toLowerCase() : ''
    const approvers = project ? project.approvers : []
    const approver = find(approvers, { _id: element.approver_id })
    const approverName = approver ?
      `${approver.emp_code.toLowerCase()} - ${approver.first_name.toLowerCase()} ${approver.last_name.toLowerCase()} (${approver.nick_name.toLowerCase()})` : ''
    if (approverName.includes(search)
    || projectCode.includes(search)
    || projectName.includes(search)) return true
    const result = find(get(element, 'tasks', []), (task) => {
      const location = find(locations, { value: task.location_id })
      const locationName = location ? location.label.toLowerCase() : ''
      const taskName = task.task_name.toLowerCase()
      return locationName.includes(search) || taskName.includes(search)
    })
    return result
  })
}

const sumTotalHoursProject = (project) => {
  let sum = 0
  get(project, 'tasks', []).forEach(task => {
    get(task, 'times', []).forEach(time => {
      sum += Number(get(time, 'hours', 0))
    })
  })
  return sum
}

export const DataRow = (props) => {
  const projects = get(props, 'timesheetRequest.projects', [])
  const holidaysStatus = timesheetHelper.changeFormatDate(get(props, 'timesheetRequest.holidays', []))
  const month = get(props, 'timesheetRequest.timesheetRequest.timesheet_snapshot.month')
  const compensateRequests = get(props, 'timesheetRequest.compensateRequests')
  const leaveRequests = get(props, 'timesheetRequest.leavesRequests')
  const { locations, searchApprovalDetail } = props
  let timesheetRequest = get(props, 'timesheetRequest.timesheetRequest.timesheet_snapshot.projects', [])
  timesheetRequest = filterTimesheetApproval(
    timesheetRequest, projects, locations, searchApprovalDetail)

  return (
    <Wrapper id='printDataRow'>
      {
        timesheetRequest.map((project) => {
          const sumTotalProject = sumTotalHoursProject(project)
          return (
            <InfoRow key={ shortid() }>
              <InfoContainer>
                <InfoData
                  project={ project }
                  projects={ props.projects }
                  { ...props }
                />
                <EmptyInput
                  project={ project }
                  sumTotalProject={ sumTotalProject }
                  task={ get(project, 'tasks', [])[0] }
                  month={ month }
                  { ...props }
                  leaveRequests={ leaveRequests }
                  compensateRequests={ compensateRequests }
                  holidaysStatus={ holidaysStatus }
                />
              </InfoContainer>
              <Container>
                <ApproverRow
                  project={ project }
                  projects={ props.projects }
                  timesheets={ props.timesheets }
                  { ...props }
                />
                <EmptyInput
                  project={ project }
                  task={ get(project, 'tasks', [])[0] }
                  month={ month }
                  { ...props }
                  leaveRequests={ leaveRequests }
                  compensateRequests={ compensateRequests }
                  holidaysStatus={ holidaysStatus }
                />
              </Container>
              {
                project.tasks.map((task, taskID) => {
                  return (
                    <Container key={ shortid() }>
                      <TaskData
                        task={ task }
                        taskID={ taskID }
                        projectID={ project.key }
                        showAdd={ taskID === project.tasks.length - 1 }
                        { ...props }
                      />
                      <DataInput
                        task={ task }
                        taskID={ taskID }
                        projectID={ project.key }
                        project={ project }
                        { ...props }
                        leaveRequests={ leaveRequests }
                        compensateRequests={ compensateRequests }
                        holidaysStatus={ holidaysStatus }
                      />
                    </Container>
                  )
                })
              }
            </InfoRow>
          )
        })
      }
    </Wrapper>
  )
}

DataRow.propTypes = {
  projects: PropTypes.array,
  locations: PropTypes.array,
  searchApprovalDetail: PropTypes.string,
}
DataRow.defaultProps = {
  projects: [],
  locations: [],
  searchApprovalDetail: '',
}

const Wrapper = styled.div`
  background-color: #FFFFFF;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
`
const Container = styled.div`
  height: 40px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const InfoContainer = styled(Container)`
  min-height: fit-content;
  height: fit-content;
`
const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 2px solid #B7B7B7;
`




// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-status/data-row.js